import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { EventsProvider } from './context/EventsContext';
import { SiteProvider } from './context/SiteContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingActionButton from './components/FloatingActionButton';

// Pages
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const ExecutiveCommittee = lazy(() => import('./pages/ExecutiveCommittee'));
const Events = lazy(() => import('./pages/Events'));
const EventDetail = lazy(() => import('./pages/EventDetail'));
const Cart = lazy(() => import('./pages/Cart'));
const Membership = lazy(() => import('./pages/Membership'));
const Donations = lazy(() => import('./pages/Donations'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Contact = lazy(() => import('./pages/Contact'));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

type AppProps = {
  basename?: string;
};

export default function App({ basename = '/' }: AppProps) {
  return (
    <SiteProvider>
      <EventsProvider>
        <CartProvider>
          <Router basename={basename}>
            <ScrollToTop />
            <div className="flex flex-col min-h-screen">
              <Navbar />
              <main className="flex-grow">
                <Suspense fallback={<div role="status" className="pt-32 pb-20 text-center">Loading page…</div>}><Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/about/executive-committee" element={<ExecutiveCommittee />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/events/:slug" element={<EventDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/membership" element={<Membership />} />
                  <Route path="/donations" element={<Donations />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:id" element={<BlogDetail />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes></Suspense>
              </main>
              <Footer />
              <FloatingActionButton />
            </div>
          </Router>
        </CartProvider>
      </EventsProvider>
    </SiteProvider>
  );
}

